import { NOTIFICATION_GRID_STORAGE_KEY } from "../constances/NotificationsConstance";

export const NOTIFICATION_SEARCH_EVENT = "adc:notification-search";

export const setNotificationSearchText = (value: string) => {
  if (typeof window === "undefined") return;

  localStorage.setItem(`${NOTIFICATION_GRID_STORAGE_KEY}.search`, value);
  window.dispatchEvent(new CustomEvent(NOTIFICATION_SEARCH_EVENT, { detail: { value } }));
};
